new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  data: {

  },
})

$(document).ready(function () {
  $(function() {
    var dominio = window.location.hostname.split('.');
    if (dominio[0] == 'www') {
      dominio = dominio[1];
    } else { 
      dominio = dominio[0]+'.'+dominio[1];
    }
    var urlTroqueCommerce = "https://monopolioshoes1.troque.app.br";
    $('.seloTroqueCommerce')
      .append(
        `<li>
          <a 
            id="seloTroqueCommerce" 
            href="${urlTroqueCommerce}" 
            target="_blank" 
            datanoop="redir(this.href);"
          >
            <img 
                class="svgTroqueCommerce" 
                src="https://troquecommerce.com.br/selo-troquecommerce.png" 
                alt="A melhor plataforma de trocas e devoluções para Trocas" 
                Title="A melhor plataforma de trocas e devoluções para E-Commerce"
            >
          </a>
        </li>`
      );
  });
  if (window.matchMedia("(max-width: 991px)").matches) {
    const allFooterTitles = document.querySelectorAll('.footer-section');
    if (allFooterTitles.length > 0) {
      allFooterTitles.forEach(filter => {
        const title = filter.querySelector('.footer-title');
        const submenu = filter.querySelector('.footer-section--content');

        if (title && submenu) {
          // pega altura real do conteúdo
          const height = submenu.scrollHeight;
          submenu.style.height = `${height}px`;
          title.addEventListener('click', () => {
            title.classList.toggle('active');
            submenu.classList.toggle('active');
          });
          title.classList.add('active');
          submenu.classList.add('active');
        }
      });
    }
  }

});